export default __webpack_public_path__ + "static/media/fureverhomes2.acbf175e.png";